module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-11-1df2dbd82dab9c30a3bfeb0ba69fdc16.jpg";